import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileDialogButtonView from '@ckeditor/ckeditor5-upload/src/ui/filedialogbuttonview';
import AttachFileIcon from 'bootstrap-icons/icons/upload.svg';

const linkElementSymbol = Symbol('linkElement');
const linkTarget = '_blank';

export default class InsertImage extends Plugin {
    init() {
        const editor = this.editor;
        console.log(editor.config.get("fileUpload"));

        editor.ui.componentFactory.add('fileUpload', locale => {
            const view = new FileDialogButtonView(locale);
            view.set({
                label: 'Insert image',
                acceptedType: '*',
            });
            view.buttonView.set({
                label: 'Insert image',
                icon: AttachFileIcon,
                tooltip: true
            });
            // Callback executed once the image is clicked.
            // view.on('execute', () => {
            //     // const imageUrl = prompt('Image URL');
            //     editor.commands.execute("")
            //     editor.model.change(writer => {
            //         const imageElement = writer.createElement("uploadButton")
            //         // writer.c
            //         // Insert the image in the current selection location.
            //         editor.model.insertContent(imageElement, editor.model.document.selection);

            //     });
            // });           

            view.on('done', (evt, files) => {
                for (const file of Array.from(files)) {
                    const fileRepo = editor.plugins.get('FileRepository');
                    const loader = fileRepo.createLoader(file);
                    loader.upload();
                    console.log(loader)
                    // const fileLoader = fileRepo.getLoader(yourNativeFileInstance);                   
                    loader.on('change:uploadResponse', (evt, name, value, oldValue) => {
                        if (value.default) {
                            // editor.model.change(writer => {
                            //     let protocol = editor.config.get("video.defaultProtocol");
                            //     if (protocol == null) {
                            //         protocol = ""
                            //     }
                            //     console.log("uploaded:", protocol + value.default); // your data                        
                            //     const footnoteElement = writer.createElement('infoBox', {
                            //         "src": protocol + value.default
                            //     });
                            //     editor.model.insertContent(footnoteElement, editor.model.document.selection);
                            // });                           
                            editor.execute("link", value.default, { linkIsExternal: true, linkIsDownloadable: true, linkFoo: true, });
                        }
                    });
                }
            });

            return view;
        })
    }
}